import moment from "moment";

export function getDescrizioneSpecialita(specObj, idLingua) {
  let desc = "";
  switch (idLingua) {
    case 1:
      desc = specObj.titoloWebLang1;
      break;
    case 2:
      desc = specObj.titoloWebLang2;
      break;
    case 3:
      desc = specObj.titoloWebLang3;
      break;
    case 4:
      desc = specObj.titoloWebLang4;
      break;
    case 5:
      desc = specObj.titoloWebLang5;
      break;
    default:
      desc = specObj.descrSpecialita;
  }

  if (desc === undefined) return specObj.descrSpecialita;
  if (desc === null) return specObj.descrSpecialita;
  if (desc === "") return specObj.descrSpecialita;
  return desc;
}

// export function getLivelli(livelliSkiwork, livelloInternazionale) {
//   if (!livelloInternazionale) {
//     const livelliArray = livelliSkiwork.map((x, idx) => {
//       const el = {
//         key: x.id.toString(),
//         text: x.livello,
//         img: require(`../assets/images/livelli/${idx + 1}.jpg`),
//       };
//       return el;
//     });
//     return livelliArray;
//   } else {
//     const livelliArray = livelliSkiwork.map((x, idx) => {
//       const el = {
//         key: x.id.toString(),
//         text: x.livello,
//         img: require(`../assets/images/livelli/${idx + 1}+.jpg`),
//       };
//       return el;
//     });
//     return livelliArray;
//   }

export function getLivelli(datiScuola, idCorso) {
  const livelliFiltrati = [...datiScuola.tLivelli];

  if (idCorso !== undefined) {
    const livelliNascostiCorso = datiScuola.livelliNascosti.filter(
      (x) => x.idCorso === idCorso
    );
    for (let i = 0; i < livelliNascostiCorso.length; i++) {
      livelliFiltrati.splice(
        livelliFiltrati.findIndex(
          (x) => x.idLivelloIso === livelliNascostiCorso[i].idLivelloISO
        ),
        1
      );
    }
  }

  const livelliArray = livelliFiltrati.map((x, idx) => {
    const el = {
      key: x.id.toString(),
      text: x.livello,
      img: require(`../assets/images/livelli/${x.simbolo}.jpg`),
      infoString: x.descrizione,
    };

    return el;
  });

  return livelliArray.filter((x) => x.text.charAt(0) !== "*");
}

export function getLivelliZona(datiScuola, idZona) {
  const livelliFiltrati = [...datiScuola.tLivelli];

  if (idZona !== undefined) {
    const livelliNascostiZona = datiScuola.livelliNascostiZona.filter(
      (x) => x.idZona === idZona
    );
    for (let i = 0; i < livelliNascostiZona.length; i++) {
      livelliFiltrati.splice(
        livelliFiltrati.findIndex(
          (x) => x.idLivelloIso === livelliNascostiZona[i].idLivelloISO
        ),
        1
      );
    }
  }

  const livelliArray = livelliFiltrati.map((x, idx) => {
    const el = {
      key: x.id.toString(),
      text: x.livello,
      img: require(`../assets/images/livelli/${x.simbolo}.jpg`),
      infoString: x.descrizione,
    };

    return el;
  });

  return livelliArray;
}

export function isSchoolPromoActive(promozione, sconto, scadenza) {
  if (!promozione || !sconto || sconto <= 0) return false;
  if (!scadenza) return false;
  const today = moment().startOf("day");
  const deadline = moment(scadenza).endOf("day");
  return today.isBefore(deadline) || today.isSame(deadline, "day");
}

/**
 * Resolves the "early booking a scalare" (tiered) discount percentage applicable for a booking
 * made today, given the date of the first lesson.
 *
 * This mirrors `EarlyBookingTiers.ResolvePercentage` in
 * `Booking/SK.Booking.Core.Domain/Aggregates/Scuola/ValueObjects/EarlyBookingTiers.cs` and
 * `resolveTieredDiscount` in
 * `Booking/Frontend/SK.Booking.PortalHybrid/src/features/school-context/model/discount.ts` —
 * keep the three implementations in sync.
 *
 * The three (days, percentage) pairs are considered regardless of declaration order; pairs with
 * `days <= 0` or `percentage <= 0` are discarded. Among the remaining pairs, only those whose days
 * threshold is met (D >= days, where D is the whole number of calendar days from today to the
 * first lesson day) are eligible. The eligible pair with the highest days threshold wins; on a tie
 * in days, the highest percentage wins. If no pair is eligible, 0 is returned.
 */
export function resolveTieredDiscount(tiers, firstLessonDate) {
  if (!tiers || !firstLessonDate) return 0;

  const lessonDay = moment(firstLessonDate).startOf("day");
  if (!lessonDay.isValid()) return 0;

  const today = moment().startOf("day");
  const daysUntilFirstLesson = lessonDay.diff(today, "days");

  const candidates = [
    { days: tiers.days1, percentage: tiers.percentage1 },
    { days: tiers.days2, percentage: tiers.percentage2 },
    { days: tiers.days3, percentage: tiers.percentage3 },
  ];

  const eligible = candidates
    .filter((t) => t.days > 0 && t.percentage > 0)
    .filter((t) => daysUntilFirstLesson >= t.days)
    .sort((a, b) => b.days - a.days || b.percentage - a.percentage);

  return eligible.length > 0 ? eligible[0].percentage : 0;
}

/**
 * Whether the school has selected the tiered ("a scalare") mode for the given lesson type.
 * `tipo` is caller-facing ("corsi" | "private"); the payload keys are named `collettivi*`/`private*`
 * so the mapping is: "corsi" -> collettiviTiered, "private" -> privateTiered.
 * This flag is meaningful even when the corresponding tiers object is null (tiered mode selected
 * but the promo itself is switched off).
 */
export function isTieredMode(promozioniNew, tipo) {
  const settings = promozioniNew?.earlyBookingTieredSettings;
  if (!settings) return false;
  if (tipo === "corsi") return settings.collettiviTiered === true;
  if (tipo === "private") return settings.privateTiered === true;
  return false;
}

/**
 * Returns the effective early-booking discount percentage for a school, for the given lesson
 * type ("corsi" | "private"), taking into account whether the school runs in tiered ("a scalare")
 * or flat mode. In flat mode, falls back to today's legacy behaviour via `isSchoolPromoActive` on
 * the legacy `datiScuolaLegacy` fields.
 */
export function getSchoolDiscountPercentage(promozioniNew, datiScuolaLegacy, tipo, firstLessonDate) {
  if (isTieredMode(promozioniNew, tipo)) {
    const tierKey = tipo === "corsi" ? "collettivi" : "private";
    const tiers = promozioniNew?.earlyBookingTieredSettings?.[tierKey];
    return resolveTieredDiscount(tiers, firstLessonDate);
  }

  if (tipo === "corsi") {
    return isSchoolPromoActive(
      datiScuolaLegacy.promozioneCorsi,
      datiScuolaLegacy.scontoPromozioneCorsi,
      datiScuolaLegacy.scadenzaPromozioneCorsi
    )
      ? datiScuolaLegacy.scontoPromozioneCorsi
      : 0;
  }

  return isSchoolPromoActive(
    datiScuolaLegacy.promozionePriv,
    datiScuolaLegacy.scontoPromozionePriv,
    datiScuolaLegacy.scadenzaPromozionePriv
  )
    ? datiScuolaLegacy.scontoPromozionePriv
    : 0;
}

export function getEffectiveCourseDiscount(corso, datiScuola, promozioniNew, firstLessonDate) {
  if (isTieredMode(promozioniNew, "corsi")) {
    // Explicit product decision: when collective tiered mode is on, the per-course promo is
    // ignored entirely (even a 0% tiered result wins - no fallback to the per-course promo).
    const tiers = promozioniNew?.earlyBookingTieredSettings?.collettivi;
    return resolveTieredDiscount(tiers, firstLessonDate);
  }

  const isCoursePromo = corso?.promozione ?? corso?.Promozione;
  if (isCoursePromo) {
    const sconto = corso.scontoPromozione ?? corso.ScontoPromozione;
    const scadenza = corso.scadenzaPromozione ?? corso.ScadenzaPromozione;
    if (sconto != null && sconto > 0 && scadenza != null) {
      const today = moment().startOf("day");
      const deadline = moment(scadenza).endOf("day");
      if (today.isBefore(deadline) || today.isSame(deadline, "day")) {
        return sconto;
      }
    }
    return 0;
  }
  const schoolPromoActive = isSchoolPromoActive(
    datiScuola.promozioneCorsi,
    datiScuola.scontoPromozioneCorsi,
    datiScuola.scadenzaPromozioneCorsi
  );
  return schoolPromoActive ? datiScuola.scontoPromozioneCorsi : 0;
}

export function applyDiscountRounding(tot, mode) {
  switch (mode) {
    case 0:
      return tot;

    case 1:
      return Math.round(tot);

    case 2: {
      const floor = Math.trunc(tot);
      if (tot === floor) return tot;
      return tot - floor < 0.5 ? floor : floor + 0.5;
    }

    case 3:
      return Math.trunc(tot);

    case 4: {
      const floor = Math.trunc(tot);
      if (tot === floor) return tot;
      return tot - floor < 0.5 ? floor + 0.5 : floor + 1;
    }

    case 5:
      return tot !== Math.trunc(tot) ? Math.trunc(tot) + 1 : tot;

    default:
      return tot;
  }
}

/**
 * Quante volte il prezzo di una riga va contato.
 *
 * Le "Offerte / Pacchetti" (corsi con flag CorsoPrivato) hanno un listino indicizzato per numero
 * di persone anziché per giornate: il prezzo è già il totale della comitiva e non va moltiplicato
 * per il numero di allievi. Tutte le altre righe restano a prezzo per allievo.
 *
 * Il marcatore `prezzoTotale` sulla riga è solo presentazionale: il server ricava l'autorità dal
 * flag t_Corsi.CorsoPrivato.
 */
export function moltiplicatoreAllievi(riga) {
  if (riga?.prezzoTotale) return 1;
  return riga?.numAllievi ?? 1;
}

export function calculateDiscountedPrice(basePrice, promoPerc, agencyPerc, roundingMode) {
  let tempPrice = basePrice;
  if (agencyPerc > 0) {
    tempPrice = tempPrice * (1 - agencyPerc / 100);
  }
  if (promoPerc > 0) {
    tempPrice = tempPrice * (1 - promoPerc / 100);
  }
  return applyDiscountRounding(tempPrice, roundingMode ?? 0);
}
